export default __webpack_public_path__ + "static/media/bgimg3.8ea006e7.jpg";